import React from 'react';
import { Wifi, Thermometer, Flame, Car, Tv, TreePine, Users, Bath, UtensilsCrossed, Plane } from 'lucide-react';
import { apartmentInfo, apartmentImages } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';

const About = () => {
  const { t, language } = useLanguage();
  
  const features = [
    { icon: Wifi, label: t.amenities.wifi },
    { icon: Thermometer, label: t.amenities.ac },
    { icon: Flame, label: t.amenities.heating },
    { icon: Car, label: t.amenities.parking },
    { icon: Tv, label: t.amenities.tv },
    { icon: TreePine, label: t.amenities.parkView },
    { icon: Bath, label: language === 'en' ? 'Modern bathroom' : 'Moderno kupatilo' },
    { icon: UtensilsCrossed, label: language === 'en' ? 'Equipped kitchen' : 'Opremljena kuhinja' },
    { icon: Plane, label: t.amenities.airportTransfer },
  ];

  return (
    <section id="o-apartmanu" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-amber-700 text-sm font-medium tracking-wider mb-2">{t.about.subtitle}</p>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900">
            {t.about.title}
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={apartmentImages[3].src}
                alt={language === 'en' ? 'Living room' : 'Dnevni boravak'}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 rounded-xl overflow-hidden shadow-xl hidden md:block">
              <img
                src={apartmentImages[0].src}
                alt={language === 'en' ? 'Bedroom' : 'Spavaća soba'}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Content */}
          <div>
            <p className="text-gray-600 text-lg leading-relaxed mb-4">
              {t.about.description}
            </p>
            <p className="text-gray-600 leading-relaxed mb-8">
              {t.about.fullDescription}
            </p>

            {/* Quick Info */}
            <div className="grid grid-cols-3 gap-4 mb-8 p-4 bg-amber-50 rounded-xl">
              <div className="text-center">
                <p className="text-xs text-gray-500 mb-1">{t.about.capacity}</p>
                <p className="font-semibold text-gray-900 text-sm">{t.about.capacityValue}</p>
              </div>
              <div className="text-center border-x border-amber-200">
                <p className="text-xs text-gray-500 mb-1">{t.about.checkIn}</p>
                <p className="font-semibold text-gray-900 text-sm">{t.about.checkInValue}</p>
              </div>
              <div className="text-center">
                <p className="text-xs text-gray-500 mb-1">{t.about.checkOut}</p>
                <p className="font-semibold text-gray-900 text-sm">{t.about.checkOutValue}</p>
              </div>
            </div>

            {/* Features Grid */}
            <div className="grid grid-cols-3 gap-4">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center p-4 bg-stone-50 rounded-xl hover:bg-amber-50 transition-colors duration-300 group"
                >
                  <feature.icon
                    size={28}
                    className="text-amber-700 mb-2 group-hover:scale-110 transition-transform duration-300"
                  />
                  <span className="text-xs text-gray-600 text-center">{feature.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
